import React, { useEffect, useState } from 'react';
import axios from 'axios';
import Cookies from 'js-cookie';
import SaveModal from '../modal/saveModal';
import '../../common/css/serviceDetail.css';

function EmdDetail() {
    const [modalAction, setModalAction] = useState(null);
    const [modalContent, setModalContent] = useState(null);
    const [saveStatus, setSaveStatus] = useState(true);
    const [detailData, setDetailData] = useState(true);
    const [status, setStatus] = useState({
        0: '요청중',
        1: '접수완료',
        2: '접수불가(티켓 불일치)',
        3: '접수불가(PNR 조회불가)',
        4: '접수불가(AISLE 불가)',
        5: '접수불가(NO SHOW)',
        6: '접수불가(탑승객 불일치)',
        8: '접수불가(좌석번호 불일치)',
        7: '기타',
    });

    // 서버통신
    useEffect(() => {
        const axiosData = async () => {
            try {
                const params = new URLSearchParams(window.location.search);
                const seq = params.get('seq') ?? 1;

                const hostname = window.location.hostname;
                let isLocal = null;
                if (hostname === 'wpal.philippineair.co.kr') {
            isLocal = true;
        } else {
            isLocal = false;
        }

                const response = await axios.get(
                    `${
                        isLocal
                            ? process.env.REACT_APP_PRODUCTION_API_URL
                            : process.env.REACT_APP_LOCAL_API_URL
                    }/wpal/board/emd/detail?seq=${seq}`,
                    {
                        withCredentials: true,
                    },
                );
                console.log(response.data);
                setDetailData(response.data);
            } catch (error) {
                console.error(error);
            }
        };

        if (Cookies.get('isLogin')) {
            axiosData();
        } else {
            setModalContent('로그인 후 이용 가능한 서비스 입니다.');
            setModalAction(() => () => (window.location.href = '/login'));
            setSaveStatus(false);
        }
    }, []);

    const requestDelete = async () => {
        try {
            const hostname = window.location.hostname;
                let isLocal = null;
                if (hostname === 'wpal.philippineair.co.kr') {
                    isLocal = true;
                } else {
                    isLocal = false;
                }

            const seq = window.location.search.split('=')[1];
            const response = await axios.post(
                `${
                    isLocal
                        ? process.env.REACT_APP_PRODUCTION_API_URL
                        : process.env.REACT_APP_LOCAL_API_URL
                }/wpal/board/emd/delete/${seq}`,
                {},
                {
                    withCredentials: true,
                },
            );

            if (response.data.rowsAffected[0] === 1) {
                setModalContent('삭제 완료되었습니다.');
                setModalAction(() => () => window.location.href = '/service/emdticketlist');
                setSaveStatus(false);
            }
        } catch (error) {
            setModalContent('삭제 요청중 오류가 발생했습니다.');
            setModalAction(() => () => setSaveStatus(true));
            setSaveStatus(false);
        }
    };

    return (
        <div className='bodyContainer '>
            <div class='subp_h_wrap'>
                <div class='subp_h_list subp_h_home'>
                    <div>서비스요청</div>
                    <div>EMD REASSOCIATE 요청</div>
                    <div>요청 내역 확인</div>
                </div>
            </div>
            <div className='wpal-contents' id='contents'>
                <div className='mypageFromWrap'>
                    <div className='page_hgroup'>
                        <h2 className='title'>EMD REASSOCIATE 요청 상세</h2>
                    </div>
                    <div className='agentCheckWrap'>
                        <h4>요청 내용</h4>

                        <table className='mypage-table'>
                            <tbody>
                                <tr className='firstTable-border'>
                                    <th>담당자</th>
                                    <td>
                                        <div className='table-padding wpal-divWeight' id='name'>
                                            {detailData.regAgtName}
                                        </div>
                                    </td>
                                </tr>
                                <tr>
                                    <th>휴대폰번호</th>
                                    <td>
                                        <div
                                            className='table-padding wpal-divWeight'
                                            id='userPhone'
                                        >
                                            {detailData.regAgtPhone}
                                        </div>
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                    <div className='agentCheckWrap'>
                        <h4>PNR 1</h4>

                        <table className='mypage-table'>
                            <tbody>
                                <tr className='firstTable-border'>
                                    <th>항공사 예약번호</th>
                                    <td>
                                        <div className='table-padding wpal-divWeight' id='name'>
                                            {detailData.air_pnr}
                                        </div>
                                    </td>
                                    <th>탑승객명</th>
                                    <td>
                                        <div className='table-padding wpal-divWeight' id='name'>
                                            {detailData.tkt_number}
                                        </div>
                                    </td>
                                </tr>
                                <tr>
                                    <th>ORIGIN 티켓번호</th>
                                    <td>
                                        <div
                                            className='table-padding wpal-divWeight'
                                            id='userPhone'
                                        >
                                            {detailData.org_flight}
                                        </div>
                                    </td>
                                    <th>REASSO 요청 EMD</th>
                                    <td>
                                        <div
                                            className='table-padding wpal-divWeight'
                                            id='userPhone'
                                        >
                                            {detailData.new_flight}
                                        </div>
                                    </td>
                                </tr>
                                <tr>
                                    <th>좌석번호 / 편명 및 일자</th>
                                    <td>
                                        <div
                                            className='table-padding wpal-divWeight wpal-divWeight wpal-textcolor'
                                            id='userPhone'
                                        >
                                            {detailData.tkt_email_address}
                                        </div>
                                    </td>
                                </tr>
                                <tr>
                                    <th>비고</th>
                                    <td colSpan={3}>
                                        <div
                                            className='table-padding wpal-divWeight'
                                            id='userPhone'
                                        >
                                            {detailData.freeMemo}
                                        </div>
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                    <div className='agentInfo'>
                        <h4>처리 결과</h4>

                        <table className='mypage-table'>
                            <tbody>
                                <tr className='firstTable-border'>
                                    <th>상태</th>
                                    <td>
                                        <div className='table-padding wpal-divWeight' id='status'>
                                            {status[detailData.status]}
                                        </div>
                                    </td>
                                </tr>
                                <tr>
                                    <th>항공사 비고</th>
                                    <td colSpan={3}>
                                        <div className='table-padding wpal-divWeight wpal-remark'>
                                            {detailData.status_other_reason == 'null'
                                                ? ''
                                                : detailData.status_other_reason}
                                        </div>
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                    {status[detailData.status] === '요청중' ? (
                    <div className='submitArea' style={{ display: 'flex', gap: '75px' }}>
                        <input
                            class={`each-button`}
                            type='button'
                            value='삭제하기'
                            onClick={() => requestDelete()}
                        />                        
                    </div>
                    ) : (
                        <></>
                    )}
                </div>
            </div>
            <SaveModal content={modalContent} SaveBtn={saveStatus} onClose={modalAction} />
        </div>
    );
}

export default EmdDetail;
